"use strict";

exports.__esModule = true;
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _Provider = _interopRequireDefault(require("material-ui-shell/lib/providers/Menu/Provider"));

var _Provider2 = _interopRequireDefault(require("material-ui-shell/lib/providers/Theme/Provider"));

var _Config = require("base-shell/lib/providers/Config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var children = _ref.children;

  var _useConfig = (0, _Config.useConfig)(),
      appConfig = _useConfig.appConfig;

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Provider.default, {
    appConfig: appConfig
  }, /*#__PURE__*/_react.default.createElement(_Provider2.default, {
    appConfig: appConfig
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex'
    }
  }, children))));
}

module.exports = exports.default;